import React, { Suspense } from 'react';
import { App } from 'src/components/app/app';
import { useConfig, useLanguages } from 'src/api/config';
import { useUserLang } from 'src/utils/languages';
import { AcademyProvider } from 'src/models/academy/academy';
import { ErrorBoundary } from 'react-error-boundary';
import ServiceUnavailable from 'src/components/app/ServiceUnavailable503';

const AppWrapper = () => {
    // Se obtiene la configuracion del cliente
    const config = useConfig();

    // Se obtiene el idioma inicial del cliente a través del navegador
    const userLang = useUserLang();

    // Se obtienen todos los idiomas de la plataforma
    const allApiLang = useLanguages();

    // Renderizamos el componenete principal
    return (
        <AcademyProvider>
            <App config={config} userLang={userLang} allLanguages={allApiLang} />
        </AcademyProvider>
    );
};
function myErrorFallBack({ error }) {
    if (error.status === 503) {
        return <ServiceUnavailable />;
    }
}
const AppWrapperWrapper = () => (
    <Suspense fallback={null}>
        <ErrorBoundary FallbackComponent={myErrorFallBack}>
            <AppWrapper />
        </ErrorBoundary>
    </Suspense>
);

export default AppWrapperWrapper;
